import React from 'react';

import {STATE} from 'lib/struct/page/SaveButton';

import Icon from './icon/Icon';
import styles from './Status.less';

export default class Status extends React.Component {
	render() {
		const {className, state, successText, errorText, ...props} = this.props;
		const {status: statusClass} = styles;
		const classes = [statusClass];

		if (className) {
			classes.push(className);
		}

		return (
			<div className={classes.join(' ')} {...props}>
				{state === STATE.Loading && (
					<div><Icon name='loading' />Загрузка</div>
				)}
				{state === STATE.Success && (
					<div><Icon name='yes' />{successText || 'Сохранено'}</div>
				)}
				{state === STATE.Error && (
					<div><Icon name='no' />{errorText || 'Ошибка'}</div>
				)}
			</div>
		);
	}
}

